import { useTranslation } from 'react-i18next';
import {
  LmsCertificate,
  LmsCertificatesDocument,
} from 'src/graphql/generated/graphql';
import React from 'react';
import { EntityAction } from './types';
import LmsCertificateForm from '../../../form';
import { DeleteModals } from './delete';

export const ActionModals = ({
  action,
  onClose,
  entity,
  onActionFinished,
}: {
  action: EntityAction;
  onClose: () => void;
  onSubmitted?: (action: EntityAction) => void;
  entity: LmsCertificate;
  onActionFinished?: (action: EntityAction) => void;
}) => {
  const { t } = useTranslation();

  const onFinished = () => {
    onActionFinished?.(action);
    onClose();
  };

  return (
    <>
      {action === EntityAction.Edit && (
        <LmsCertificateForm
          title={t('lms.certificates.form.edit-certificate')}
          entity={entity}
          onFinish={onFinished}
          refetchQueries={[LmsCertificatesDocument]}
          onClose={onClose}
        />
      )}
      {[EntityAction.Delete, EntityAction.Restore].includes(action) && (
        <DeleteModals
          action={action}
          onClose={onClose}
          entity={entity}
          onFinish={onFinished}
        />
      )}
    </>
  );
};
